"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParallelAction = void 0;
var tslib_1 = require("tslib");
var Action_1 = require("./Action");
var ParallelAction = (function (_super) {
    tslib_1.__extends(ParallelAction, _super);
    function ParallelAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParallelAction.prototype.execute = function (actions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var promises, actions_1, actions_1_1, action;
            var e_1, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        promises = [];
                        try {
                            for (actions_1 = tslib_1.__values(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()) {
                                action = actions_1_1.value;
                                promises.push(action.run());
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (actions_1_1 && !actions_1_1.done && (_a = actions_1.return)) _a.call(actions_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4, Promise.all(promises)];
                    case 1: return [2, _b.sent()];
                }
            });
        });
    };
    return ParallelAction;
}(Action_1.Action));
exports.ParallelAction = ParallelAction;
//# sourceMappingURL=ParallelAction.js.map